import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from 'App'
import { SESSION_QUERY_KEY } from './CheckSessionHook'

export type ResetPasswordByAdminPayload = {
  uuid: string;
};

export function useResetSuccessorPasswordByAdmin(
  options?: UseMutationOptions<any, Error, ResetPasswordByAdminPayload>
) {
  return useMutation<any, Error, ResetPasswordByAdminPayload>({
    ...options,
    mutationKey: ["resetSuccessorPasswordByAdmin"],
    mutationFn: async ({ uuid }: ResetPasswordByAdminPayload) => {
      const res = await axiosInstance.post(
        `/users/${uuid}/successors-change-password`,
      );
      return res.data;
    },
    onMutate: (variables) => {
      Toast({
        message: "Wysyłanie linku do resetu hasła...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "reset-successor-password-admin",
      });
      return options?.onMutate?.(variables);
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: "Link do resetu hasła został wysłany.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "reset-successor-password-admin",
      });
      options?.onSuccess?.(data, variables, context);
    },
    onError: (error: any, variables, context) => {
      queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY })
      Toast({
        message: "Błąd podczas wysyłania linku do resetu hasła.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "reset-successor-password-admin",
      });

      options?.onError?.(error, variables, context);
    },
  });
}

export default useResetSuccessorPasswordByAdmin;
